import { RefreshCw } from "lucide-react";
import { useSwUpdate } from "../lib/pwa";

export const BUILD_ID = process.env.REACT_APP_BUILD_ID || "dev";

export const SwUpdateBanner = () => {
  const { updateReady, applyUpdate } = useSwUpdate();
  if (!updateReady) return null;
  return (
    <button type="button" className="sw-update-banner" onClick={applyUpdate} data-testid="sw-update-banner">
      <RefreshCw size={14} /> New update available. Click here to refresh
    </button>
  );
};
